import React, {Component} from 'react'
import ReactDOM from 'react-dom';

class MediaFilterAction extends Component {

  constructor(props) {
    super(props);

    this.state = {
      months:["January","February","March","April","May","June","July","August","September","October","November","December"]
    }
  }

  handleChangeFiler(e){
    e.preventDefault();
    this.props.onFilterChange(e.target.value)
  }

  render(){
   
    return(
      <div>
        {
          this.props.typeOfMedia == 'folders' &&
          <div>
            <select
              id="sp-pagebuilder-media-filter"
              value={this.props.filtered}
              onChange={this.handleChangeFiler.bind(this)}
            >
              <option value={sppbMediaPath}>{sppbMediaPath}</option>
              {
                this.props.filters.map((filter,index) => {
                  return(
                    <option key={index} value={filter.relname} >{ filter.relname } </option>
                  )
                })
              }
            </select>
          </div>
        }
        {
          this.props.typeOfMedia != 'folders' &&
          <div>
            <select
              id="sp-pagebuilder-media-filter"
              value={this.props.filtered}
              onChange={this.handleChangeFiler.bind(this)}
            >
              <option value="">All</option>
              {
                this.props.filters.map((filter,index) => {
                  var filterValue = filter.year + '-' + filter.month;
                  return(
                    <option key={index} value={filterValue} >{ this.state.months[filter.month - 1] } { filter.year } </option>
                  )
                })
              }
            </select>
          </div>
        }
      </div>
    )
  }
}

export default MediaFilterAction;



// WEBPACK FOOTER //
// ./src/helpers/form/types/media-helper/MediaFilterAction.js